import { render, staticRenderFns } from "./managedInstructionOverdueIcon.vue?vue&type=template&id=8bd3be84"
import script from "./managedInstructionOverdueIcon.vue?vue&type=script&lang=js"
export * from "./managedInstructionOverdueIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports